import { useEffect } from 'react';
import { ArchiveIcon } from '@nimbus-ds/icons';
import {
  HeaderContent,
  IonPageStratus,
  HeaderTop,
  Responsive,
} from 'commons/components';
import { useTranslationCustomers } from 'domains/Customers/hooks';
import {
  MessagesListMobile,
  MessagesListDesktop,
  BulkActionsProvider,
  useBulkActions,
  MessagesListInitialScreen,
  MessagesListError,
  BulkActionsMessages,
  MessagesListHelpLink,
} from './components';
import useMessages from './hooks/useMessages';

function MessagesListPageWithBulkActions() {
  return (
    <BulkActionsProvider>
      <MessagesListPage />
    </BulkActionsProvider>
  );
}

function MessagesListPage() {
  const { toggleEditMode, editMode, selectedRowsId } = useBulkActions();
  const t = useTranslationCustomers();

  const { isError, isEmpty, fetchMessages } = useMessages();

  const editModeAction = editMode
    ? {
        onClick: toggleEditMode,
        children: t('common:editMode.cancel'),
      }
    : {
        onClick: toggleEditMode,
        children: t('Organizar'),
        icon: ArchiveIcon,
      };

  useEffect(() => {
    fetchMessages();
  }, [fetchMessages]);

  return (
    <IonPageStratus
      width="medium"
      headerTop={
        selectedRowsId.length === 0 &&
        !isEmpty && <HeaderTop mainAction={editModeAction} />
      }
      headerContent={
        <HeaderContent
          title={!isEmpty ? t('messages.title') : undefined}
          subtitle={!isEmpty && !isError ? t('messages.subtitle') : ''}
        />
      }
    >
      <BulkActionsMessages />
      {isEmpty && <MessagesListInitialScreen />}
      {isError && <MessagesListError onRetryError={fetchMessages} />}
      {!isEmpty && !isError && (
        <Responsive
          mobile={
            <MessagesListMobile
              isEditMode={editMode}
              onToggleEditMode={toggleEditMode}
            />
          }
          desktop={<MessagesListDesktop />}
        />
      )}

      <MessagesListHelpLink />
    </IonPageStratus>
  );
}

export default MessagesListPageWithBulkActions;
